import { createSlice } from '@reduxjs/toolkit';

import type { UserProfileRead } from 'src/common/external/bambi-api/bambiApi';
import { getStorageValue } from 'src/common/util/useLocalStorage/getStorageValue';
import { setStorageValue } from 'src/common/util/useLocalStorage/setStorageValue';

// TODO: Probably should isolate this per user id
export const currentOrgStorageKey = 'current-organization-id';

export interface IAuthState {
  profile?: UserProfileRead | null;
  currentOrganizationId?: string;
  isOrganizationChangeOpen: boolean;
}

export const initialState: IAuthState = {
  profile: null,
  isOrganizationChangeOpen: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    signIn: (state, action) => {
      state.profile = action.payload;
      let nextOrganizationId =
        getStorageValue<string | undefined>(currentOrgStorageKey, '') ||
        state.currentOrganizationId ||
        state.profile?.memberships[0]?.organization.id;

      // Verify that the user still has access to their current organization
      const currentOrganization = state.profile?.memberships.find(
        (membership) => membership.organization.id === nextOrganizationId
      );

      if (!currentOrganization) {
        nextOrganizationId = state.profile?.memberships[0]?.organization.id;

        // Since this happens from the local storage retrieval, clear it for safety
        setStorageValue(currentOrgStorageKey, '');
      }

      state.currentOrganizationId = nextOrganizationId;
    },
    changeOrganization: (state, action) => {
      state.currentOrganizationId = action.payload;
      setStorageValue(currentOrgStorageKey, state.currentOrganizationId || '');
    },
    setIsOrganizationChangeOpen: (state, action) => {
      state.isOrganizationChangeOpen = action.payload;
    },
  },
});
